import {CommonModule, Location} from "@angular/common";
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {RoutingService} from 'src/app/core/services/routing.service';
import {MyButtonComponent} from 'src/app/shared/components/buttons/my-button/my-button.component';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-page',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    BreadcrumbComponent,
    MyButtonComponent
  ],
  templateUrl: './page.component.html',
  styleUrl: './page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageComponent {
  @Input() title?: string;
  @Input() icon?: string;
  @Input() info?: string;
  @Input() padding: string = '1';
  @Input() canShowBreadcrumb?:boolean;
  constructor(
    private routingService: RoutingService,
    private location: Location
  ) {
  }

  get pageTitle() {
    return this.title ?? this.routingService.getCurrentMenuItem()?.label;
  }

  get pageIcon() {
    return this.icon ?? this.routingService.getCurrentMenuItem()?.icon;
  }

  goBack() {
    if (!this.disableBackButton()) {
      this.location.back();
    }
  }

  disableBackButton(): boolean {
    const previousUrl = this.location.path();
    const isBackToLogin = previousUrl === '/login';
    return isBackToLogin;
  }
}
